import { ASSET_METADATA_MAP } from '@colescomex/ui';
import { PHOTO_WIDTHS, type SitePhotoId } from '../content/media-manifest';

/** Approved photographic master (AVIF → WebP), responsive, never the LCP-critical element. */
export function photoSrc(id: SitePhotoId, width: (typeof PHOTO_WIDTHS)[number], format: 'avif' | 'webp') {
  const meta = ASSET_METADATA_MAP[id];
  return `/media/img/${meta.batchDir}/${meta.baseFilename}_${width}w.${format}`;
}
const srcset = (id: SitePhotoId, format: 'avif' | 'webp') => PHOTO_WIDTHS.map(width => `${photoSrc(id, width, format)} ${width}w`).join(', ');

export function Photo({ id, alt, sizes = '100vw', className, eager = false }: { id: SitePhotoId; alt: string; sizes?: string; className?: string; eager?: boolean }) {
  return (
    <picture className={className}>
      <source type="image/avif" srcSet={srcset(id, 'avif')} sizes={sizes} />
      <source type="image/webp" srcSet={srcset(id, 'webp')} sizes={sizes} />
      <img src={photoSrc(id, 960, 'webp')} alt={alt} width={1376} height={768} loading={eager ? 'eager' : 'lazy'} decoding="async" />
    </picture>
  );
}
